import axios from "axios";

const apiURL = "https://wallet.growatiopex.com/api";
// const apiURL = "http://localhost:3000/api";
console.log(apiURL);
const API = axios.create();
API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const LoginAPI = async (data, callback) => {
    try {
        const response = await API.post(apiURL + "/auth/login", data);
        callback(response.data);
    } catch (error) {
        callback(error.response?.data || { success: false });
    }
};
// API.interceptors.request.use(
//   async (config) => {
//     const authToken =
//       localStorage.getItem("token") &&
//       JSON.parse(localStorage.getItem("token"));

//     config.headers.Authorization = "Bearer " + authToken || "";
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// API.interceptors.response.use(
//   (response) => {
//     if (
//       response.data.status === 401 &&
//       response.data.message === "Unauthorized access"
//     ) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user_details");
//       localStorage.removeItem("loggedIn");
//       window.location.href = "/login"; // Redirect to login page if token expires
//     }
//     return response
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       localStorage.removeItem("token");
//       window.location.href = "/login"; // Redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

export const GetAPI = async (url, callback) => {
  await API.get(apiURL + url)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      // callback(error.response.data);
    });
};

export const PostAPI = async (paramsOrUrl, dataOrCb, maybeCb) => {
  // Support either:
  // 1) PostAPI({ url: '/x', data: payload }, callback)
  // 2) PostAPI('/x', payload, callback)
  let url;
  let data;
  let callback;

  if (typeof paramsOrUrl === 'string') {
    url = paramsOrUrl;
    data = dataOrCb;
    callback = maybeCb;
  } else if (paramsOrUrl && typeof paramsOrUrl === 'object') {
    url = paramsOrUrl.url;
    data = paramsOrUrl.data;
    callback = dataOrCb;
  } else {
    // invalid usage
    callback = maybeCb || (() => {});
    return callback({ success: false, error: 'Invalid PostAPI arguments' });
  }

  // ensure callback is a function
  if (typeof callback !== 'function') callback = () => {};

  try {
    const response = await API.post(apiURL + url, data);
    callback(response?.data);
    return response?.data;
  } catch (error) {
    callback(error);
    console.error(error);
    // also return/throw so callers that use Promise style can handle it
    return error;
  }
};

export const PatchAPI = async ({ url, data }, callback) => {
  await API.patch(apiURL + url, data)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response.data);
    });
};

export const DeleteAPI = async ({ url, data }, callback) => {
  await API.delete(apiURL + url, { data: data })
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response.data);
    });
};

export const Delete_params = async (url, callback) => {
  await API.delete(apiURL + url)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response.data);
    });
};

export const PutAPI = async ({ url, data }, callback) => {
  await API.put(apiURL + url, data)
    .then(function (response) {
      callback(response?.data);
    })
    .catch(function (error) {
      callback(error);
      console.log(error);
    });
};

